import { getBffClient } from '../client/http';

export const getLinkedInUserInfo = async (
  code: string,
  redirect_uri: string,
) => {
  try {
    const response = await getBffClient().post(
      `/api/linkedin/get-user-info?code=${code}&redirect_uri=${redirect_uri}`,
    );

    return response.data;
  } catch (err: any) {
    throw new Error(
      `Error getting LinkedIn user info: ${err.response?.data?.error}`,
    );
  }
};
